<template>
    <div class="interface-help">
        <h2>Программа инвентаризации</h2>
        <p>
            Данный интерфейс, имитирует работу с программой инвентаризации. Программа инвенторизации представляет собой список жанров, и из количества в общей базе.
        </p>
        <p>
            Если количество фильмов определенного жанра не известно, появляется поле для ввода данных<br>
            <img class="interface-help__image interface-help__image--1" src="/images/help/inventory-input.jpg" alt="">
        </p>
        <p>
            Для сохранения количества введенных фильмов, нужно нажать кнопку сохранения<br>
            <img class="interface-help__image interface-help__image--2" src="/images/help/inventory-button.jpg" alt="">
        </p>
        <p>
            Введенное количество дисков, сохраняется после появления соответствующего попапа<br>
            <img class="interface-help__image interface-help__image--3" src="/images/help/inventory-popup.png" alt="">
        </p>
        <p>
            Общий вид отправки электронной почты<br>
            <img class="interface-help__image" src="/images/help/inventory.jpg" alt="">
        </p>
    </div>
</template>
<script>
    export default {}
</script>
<style lang="stylus" scoped>
    .interface-help {
        p {
            max-width 80%
        }

        &__image {
            max-width 60%
            border 1px solid rgba(0, 0, 0, .4)

            &--1 {
                max-width 500px
            }

            &--2 {
                max-width 348px
            }

            &--3 {
                max-width 500px
            }
        }
    }
</style>